import Enums from '../helpers/Enums'

export default {
  // created: function () {
  //   this.hello()
  // },
  methods: {
    getOsdTileSources(mediaCollection) {
      const self = this
      return mediaCollection.map(m => {
        return self.getOsdTileSource(m)
      })
    },
    getOsdTileSource(media) {
      const self = this
      if (this.isMediaDzi(media)) {
        return {
          width: media.mediaData.width,
          height: media.mediaData.height,
          tileWidth: media.mediaData.tileWidth,
          tileHeight: media.mediaData.tileHeight,
          getTileUrl: function(level, x, y) {
            return self.getDziTileSourceUrl(media, level, x, y)
          }
          // type: 'image',
          // url: 'url-to-image.jpg'
        }
      } else {
        return {
          type: 'legacy-image-pyramid',
          levels: [
            {
              url: `${process.env.VUE_APP_API_URL}/pois/${
                this.$store.state.PoiStore.selectedPoi.id
              }/media-content/${media.id}/file`
            }
          ]
        }
      }
    },
    getDziTileSourceUrl(media, level, x, y) {
      if (this.isMediaDzi(media)) {
        return `${process.env.VUE_APP_API_URL}/pois/${
          this.$store.state.PoiStore.selectedPoi.id
        }/media-content/${
          media.id
        }/file?type=dzi_tile&level=${level}&x=${x}&y=${y}`
      } else {
        return ''
      }
    },
    isMediaDzi(media) {
      if (
        media &&
        media.path &&
        media.path.toLowerCase().indexOf('.dzi') !== -1
      ) {
        return true
      } else return false
    }
  }
}
